import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';

import useI18n from 'hooks/I18n/useI18n';
import { toggle as togglePanel, HELP_PANEL } from 'modules/visiblePanel';
import HelpCenterContainer from 'components/Navigation/HelpCenter/HelpCenterContainer.jsx';
import ResponsiveSidePanel, {
    POSITION_RIGHT,
} from 'components/Navigation/ProductIdentity/ResponsiveSidePanel.jsx';

const HelpPanel = props => {
    const { currentAssembly, farm, user, fullHeight } = props;
    const dispatch = useDispatch();
    const onClose = () => dispatch(togglePanel(HELP_PANEL));
    const { trans } = useI18n();
    const panelTitle = user.anonymous
        ? trans('menu.help.title')
        : `${user.firstName} ${user.lastName}`;
    return (
        <ResponsiveSidePanel
            isOpened
            position={POSITION_RIGHT}
            onClose={onClose}
            title={panelTitle}
            className={classNames('simpleMemberTopNavigation-helpPanel', { fullHeight })}
            isNewNavigationLayout
        >
            <HelpCenterContainer
                user={user}
                currentAssembly={currentAssembly || null}
                farm={farm}
            />
        </ResponsiveSidePanel>
    );
};

HelpPanel.propTypes = {
    currentAssembly: PropTypes.object,
    farm: PropTypes.object,
    user: PropTypes.object,
    fullHeight: PropTypes.bool,
};
export default HelpPanel;
